import React from 'react';
import { Tag, theme } from 'antd';
import { photoLabel, photoPartIdentity } from '../models/photoTags';
import './photo-tags.css';
export function PhotoTagCorner({ photo, parts }) {
  return <Tag color={photo?.part_removed ? 'orange' : undefined} style={{ position: 'absolute', right: 0, top: 0, zIndex: 1, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', pointerEvents: 'none', margin: 0, fontSize: 10 }}>{photoLabel(photo, parts)}</Tag>;
}

export function PhotoTagPicker({ photo, parts, onChange, disabled = false }) {
  const { token } = theme.useToken();
  const selected = photo?.query_part_ids || [];
  const active = parts.filter(part => !part.disabled && !part.cancelled && part.status !== 'disabled' && part.status !== 'cancelled');
  const chip = (key, label, checked, change) => <Tag.CheckableTag key={key} checked={checked}
    role="checkbox" aria-label={label} aria-checked={checked} aria-disabled={disabled}
    tabIndex={disabled ? -1 : 0} onKeyDown={event => {
      if (!disabled && (event.key === ' ' || event.key === 'Enter')) { event.preventDefault(); change(); }
    }} onChange={() => !disabled && change()} style={{
      border: `1px solid ${checked ? token.colorInfoBorder : token.colorBorder}`,
      background: checked ? token.colorInfoBg : token.colorBgContainer,
      color: checked ? token.colorInfoText : token.colorTextSecondary,
      opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer',
    }}><span aria-hidden="true">{checked ? '✓ ' : ''}</span><span>{label}</span></Tag.CheckableTag>;
  return <div className="query-photo-tag-picker">
    <div style={{ color: token.colorTextSecondary, fontSize: 11 }}>Shows</div>
    {chip('general', 'General', !photo?.part_removed && (!photo || photo.general), () => onChange([]))}
    {active.filter(part => photoPartIdentity(part) != null).map(part => {
      const id = photoPartIdentity(part), duplicate = active.filter(item => item.part_name === part.part_name).length > 1;
      return chip(id, `${part.part_name}${duplicate && part.side ? ` · ${part.side}` : ''}`, selected.includes(id),
        () => onChange(selected.includes(id) ? selected.filter(value => value !== id) : [...selected, id]));
    })}
  </div>;
}
